
import { z } from "zod";

// Define the schema for the form
export const organizationFormSchema = z.object({
  // Basic info (existing fields)
  name: z.string().min(1, "Organization name is required"),
  industry: z.string().optional(),
  description: z.string().optional(),
  website: z.string().url("Must be a valid URL").or(z.string().length(0)).optional(),
  status: z.string().default("active"),
  tier: z.string().default("standard"),
  
  // Additional fields
  client_type: z.string().optional(),
  social_instagram: z.string().optional(),
  social_facebook: z.string().optional(),
  social_linkedin: z.string().optional(),
  social_tiktok: z.string().optional(),
  personality: z.string().optional(),
  gift_preferences: z.string().optional(),
  gender_preference: z.string().optional(),
  client_goals: z.string().optional(),
  start_date: z.date().optional().nullable(),
  contract_renewal_date: z.date().optional().nullable(),
  reporting_cycle: z.string().optional(),
  retainer_type: z.string().optional(),
  contract_value: z.coerce.number().positive().nullable().optional(),
  monthly_retainer: z.coerce.number().positive().nullable().optional(),
  org_mapping: z.string().optional(),
  org_chart_notes: z.string().optional(),
  referral_source: z.string().optional(),
});

export type OrganizationFormValues = z.infer<typeof organizationFormSchema>;
